import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import SellerNavbar from './SellerNavbar';
import WorkflowAlertToast from '../../components/WorkflowAlertToast';

const SellerLayout = () => (
  <ProtectedRoute allowedRoles={['seller', 'admin']}>
    <div className="min-h-screen bg-gray-50">
      <SellerNavbar />
      <main className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <Outlet />
      </main>
      <WorkflowAlertToast />
    </div>
  </ProtectedRoute>
);

export default SellerLayout;
